import * as actions from "./actionsTypes";

const initialData = {
  loaderMatrixNineBoxes: false,
  matrixNineBoxes: null,
  matrixNineBoxesAnio: null,
  matrixNineBoxesFail: null,
  saveLoaderMatrixNineBoxes: false,
  matrixNineBoxesFormError: null,
  
};

export default function MatrixNineBoxesReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_MATRIX_NINE_BOXES:
      return { ...state, loaderMatrixNineBoxes: action.payload };

    case actions.GET_MATRIX_NINE_BOXES:
      return { ...state, matrixNineBoxes: action.payload.matrixNineBoxes, matrixNineBoxesAnio: action.payload.matrixNineBoxesAnio };

    case actions.MATRIX_NINE_BOXES_FAIL:
      return { ...state, matrixNineBoxesFail: action.payload };

    case actions.SAVE_LOADER_MATRIX_NINE_BOXES:
      return { ...state, saveLoaderMatrixNineBoxes: action.payload };

    case actions.FORM_MATRIX_NINE_BOXES_FAIL:
      return { ...state, matrixNineBoxesFormError: action.payload };

    default:
      return state;
  }
}
